import { Button, Stack, useTheme } from "@mui/material";
import { MessageCircle } from "lucide-react";
import type { FC } from "react";
import { RealizationSummary } from "web_myplann/Goals/Components/RealizationSummary";
import type { RealizationStep } from "web_myplann/Goals/Hooks/useRealizationContent";

type Props = {
	kicker: string;
	title: string;
	description: string;
	steps: RealizationStep[];
	contactLabel: string;
	onContact: () => void;
};

export const InspirationReadyBox: FC<Props> = ({
	kicker,
	title,
	description,
	steps,
	contactLabel,
	onContact,
}) => {
	const theme = useTheme();

	return (
		<Stack
			px={theme.spacingTokens.lg}
			pt={theme.spacingTokens.lg}
			pb={theme.spacingTokens.xl}
			gap={theme.spacingTokens.lg}
			sx={{ background: theme.gradients.realization }}
		>
			<RealizationSummary
				kicker={kicker}
				title={title}
				description={description}
				steps={steps}
			/>

			<Button
				variant="primary"
				color="success"
				startIcon={<MessageCircle size={theme.iconSize.sm} />}
				onClick={onContact}
			>
				{contactLabel}
			</Button>
		</Stack>
	);
};
